import _ from 'lodash';

const Session = (props) => {
    return (
        <>
            <div
                className={`session${_.isNil(props.className) ? '' : ' ' + props.className}`}
                style={props.style}
            >
                <div className='wrapper'>
                    <div
                        {...props}
                        className='box'
                        style={null}
                    />
                </div>
            </div>
        </>
    );
};

export default Session;
